export default __webpack_public_path__ + "img/star-gray.80ecb29f.svg";